import { ISingleEpletMmRisk } from "../single-eplet-mm-risk";

export interface IExpertSystemOrderByRecipient {
    id: number,

    donorId: number,
    donorAlias: string,
    donorName: string,
    donorBirthDate: string,
    donorAbo: string,
    donorCenterId: number,
    donorCenterAlias: string,
    donorRdnCenterId: number,
    donorRdnCenterAlias: string,
    donorRegistrationId: number,
    donorOrderId: number,

    recipientId: number,
    recipientAlias: string,
    recipientName: string,
    recipientBirthDate: string,
    recipientAbo: string,
    recipientOrderId: number,

    statusId: number,
    status: string,

    ordersSentDateTime: string,
    donorResultsReceivedDateTime: string,
    recipientResultsReceivedDateTime: string,
    alertSentDateTime: string,
    alertAcknowledgedDateTime: string,

    recomendation: string,
    comments: string,

    singleEpletMmRisk: ISingleEpletMmRisk,


}